import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import React from "react";
import variables from "./variables.js";
import MATCHES from "./matches.js";
const useMedia = query => {
  const [matches, setMatches] = React.useState(MATCHES.NOT_SURE);
  const media = React.useRef();
  const handleMediaChange = mediaEvent => {
    setMatches(mediaEvent.matches ? MATCHES.YES : MATCHES.NO);
  };
  React.useEffect(() => {
    media.current = _globalThis.matchMedia(query);
    handleMediaChange(media.current);
    media.current.addEventListener('change', handleMediaChange);
    return () => {
      media.current.removeEventListener('change', handleMediaChange);
    };
  }, [query]);
  return {
    matches,
    yes: matches === MATCHES.YES,
    no: matches === MATCHES.NO,
    notSure: matches === MATCHES.NOT_SURE
  };
};
export const useMobileMedia = () => useMedia(`(${variables.inMobile})`);
export const useDesktopMedia = () => useMedia(`(${variables.inDesktop})`);
const strictGet = function (obj, key) {
  let keysAllowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Object$keys(obj);
  if (!_includesInstanceProperty(keysAllowed).call(keysAllowed, key)) throw new Error(`Invalid key: ${key.toString()}. Valid keys: ${keysAllowed.join(', ')}`);
  return obj[key];
};
const screenSizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
export const useMediaScreenMin = screenSize => useMedia(`(min-width: ${strictGet(variables, screenSize, screenSizes)})`);
export const useMediaScreenMax = screenSize => useMedia(`(max-width: ${strictGet(variables, `${screenSize}Max`, ['xsMax', 'smMax', 'mdMax', 'lgMax', 'xlMax'])})`);
export default useMedia;